/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestAddOnlyAddressListOwner extends Contract<ITestAddOnlyAddressListOwner> {
  addValidatedItemsToList: Send<(_items: AddressLike[]) => void, ITestAddOnlyAddressListOwner>
  'addValidatedItemsToList(address[])': Send<(_items: AddressLike[]) => void, ITestAddOnlyAddressListOwner>
}

let ITestAddOnlyAddressListOwnerBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestAddOnlyAddressListOwnerBytecode = '0x';
}

// prettier-ignore
export const ITestAddOnlyAddressListOwner = contract<ITestAddOnlyAddressListOwner>(ITestAddOnlyAddressListOwnerBytecode)`
  function addValidatedItemsToList(address[] _items)
`;